import { Typography } from '@material-ui/core';
import React from 'react';
import * as pjson from '../../package.json';
import { makeStyles } from '@material-ui/core/styles';
import classeNames from 'classnames';

const useStyles = makeStyles(() => ({
	versionDisplay: { position: 'fixed', right: '8px', bottom: '11px', fontSize: '10px', lineHeight: '0' },
}));
// Component to display version and build info on all pages.
const VersionDisplay = () => {
	const classes = useStyles();
	const versionDisplayClasses = classeNames({
		[classes.versionDisplay]: true,
		noselect: true,
	});
	let envName = process.env.REACT_APP_ENV === 'production' ? 'prod' : 'dev';
	const build = process.env.REACT_APP_BUILD ?? 'local';
	const version = `${pjson.version}-${envName}-${build}`;
	return (
		<Typography data-cy="version-display-container" className={versionDisplayClasses}>
			v{version}
		</Typography>
	);
};
export default VersionDisplay;
